import type { PayloadAction } from '@reduxjs/toolkit';
import type { GlobalState } from './globalReducerTypes';
import type { RootState } from '../index';
import type { DeployStatusForTable } from '../../types/enums/DeployStatusForTable';

type scheduledJobReducersProps = {
  addScheduledJob: (
    state: GlobalState,
    action: PayloadAction<{
      crmOrgId: string;
      automation: AutomationStructureNew;
      optimisticStatus: DeployStatusForTable;
    }>,
  ) => any;
  updateScheduledJob: (
    state: GlobalState,
    action: PayloadAction<{
      crmOrgId: string;
      automationToUpdate: AutomationStructureNew;
      versionIdToUpdate: string;
      optimisticStatus: DeployStatusForTable;
    }>,
  ) => any;
  toggleScheduledJob: (
    state: GlobalState,
    action: PayloadAction<{
      crmOrgId: string;
      automationToUpdate: AutomationStructureNew;
      versionIdToUpdate: string;
      optimisticStatus: DeployStatusForTable;
    }>,
  ) => any;
  deleteScheduledJob: (
    state: GlobalState,
    action: PayloadAction<{
      crmOrgId: string;
      automationIdToDelete: string;
    }>,
  ) => any;
  updateScheduledJobDeployStatus: (
    state: GlobalState,
    action: PayloadAction<{
      crmOrgId: string;
      automationId: string;
      versionId: string;
      optimisticStatus: DeployStatusForTable;
    }>,
  ) => any;
};
export const scheduledJobReducers: scheduledJobReducersProps = {
  addScheduledJob: (state, action) => {
    const { crmOrgId, automation, optimisticStatus } = action.payload;
    if (!state.environments[crmOrgId]?.data) {
      return;
    }
    if (!state.environments[crmOrgId].data.scheduledJob) {
      state.environments[crmOrgId].data.scheduledJob = [];
    }
    state.environments[crmOrgId].data.scheduledJob?.push({
      ...automation,
      status: optimisticStatus,
    });
  },
  updateScheduledJob: (state, action) => {
    const { crmOrgId, automationToUpdate, versionIdToUpdate, optimisticStatus } = action.payload;
    if (!state.environments[crmOrgId]?.data?.scheduledJob) {
      return;
    }
    const indexToUpdate = state.environments[crmOrgId].data.scheduledJob?.findIndex(
      (r) =>
        r.automationId === automationToUpdate.automationId && r.versionId === versionIdToUpdate,
    );
    if (indexToUpdate !== undefined) {
      // @ts-ignore
      state.environments[crmOrgId].data.scheduledJob[indexToUpdate] = {
        ...automationToUpdate,
        status: optimisticStatus,
      };
    }
  },
  deleteScheduledJob: (state, action) => {
    const { crmOrgId, automationIdToDelete } = action.payload;
    if (!state.environments[crmOrgId]?.data?.scheduledJob) {
      return;
    }
    const indexToDelete = state.environments[crmOrgId].data.scheduledJob?.findIndex(
      (r) => r.automationId === automationIdToDelete,
    );
    if (indexToDelete !== undefined) {
      state.environments[crmOrgId].data.scheduledJob?.splice(indexToDelete, 1);
    }
  },
  toggleScheduledJob: (state, action) => {
    const { crmOrgId, automationToUpdate, versionIdToUpdate, optimisticStatus } = action.payload;
    if (!state.environments[crmOrgId]?.data?.scheduledJob) {
      return;
    }
    const indexToUpdate = state.environments[crmOrgId].data.scheduledJob?.findIndex(
      (r) =>
        r.automationId === automationToUpdate.automationId && r.versionId === versionIdToUpdate,
    );
    if (indexToUpdate !== undefined) {
      // @ts-ignore
      state.environments[crmOrgId].data.scheduledJob[indexToUpdate] = {
        ...automationToUpdate,
        status: optimisticStatus,
      };
    }
  },
  updateScheduledJobDeployStatus: (state, action) => {
    const { crmOrgId, automationId, versionId, optimisticStatus } = action.payload;
    if (!state.environments[crmOrgId]?.data?.scheduledJob) {
      return;
    }
    const indexToUpdate = state.environments[crmOrgId].data.scheduledJob?.findIndex(
      (r) => r.automationId === automationId && r.versionId === versionId,
    );
    if (indexToUpdate !== undefined) {
      // @ts-ignore
      state.environments[crmOrgId].data.scheduledJob[indexToUpdate].status = optimisticStatus;
    }
  },
};

export const selectScheduledJobs = (crmOrgId: string | undefined) => (state: RootState) => {
  if (crmOrgId) {
    return state.global.environments[crmOrgId]?.data?.scheduledJob;
  }
};
